class ThemeAnchorLoaderManager {

	static SKIP_NAVIGATION_SELECTOR = [
		'[download]',
		'[data-bs-toggle]',
		'[data-bs-target]',
		'[data-toggle]',
		'[data-target]',
		'[aria-controls]',
		'[data-fancybox]',
		'[data-lightbox]',
		'[data-gallery]',
		'[data-video-modal-close]',
		'.scroll-to',
		'.open-modal-btn-3',
		'.open-gift-button',
		'[data-no-spa]',
		'.no-spa',
		'.ab-item',
	].join(',');

	constructor() {
		this.loaderSelector = 'body > #spinner-loader';
		this.timer = null;
		this.rafId = null;
		this.initialized = false;

		this.boundHandleClick = this.handleClick.bind(this);
		this.boundHideLoader = this.hideLoader.bind(this);
		this.boundHandleVisibilityChange =
			this.handleVisibilityChange.bind(this);
	}

	init() {
		if (this.initialized) {
			return;
		}

		this.initialized = true;
		document.addEventListener('click', this.boundHandleClick);
		window.addEventListener('pageshow', this.boundHideLoader);
		window.addEventListener('pagehide', this.boundHideLoader);
		window.addEventListener('popstate', this.boundHideLoader);
		window.addEventListener('hashchange', this.boundHideLoader);
		document.addEventListener(
			'visibilitychange',
			this.boundHandleVisibilityChange
		);
		this.hideLoader();
	}

	handleVisibilityChange() {
		if ('hidden' === document.visibilityState) {
			this.hideLoader();
		}
	}

	isNotPlainLeftClick(event) {
		return (
			!event ||
			event.defaultPrevented ||
			event.metaKey ||
			event.ctrlKey ||
			event.shiftKey ||
			event.altKey ||
			0 !== event.button
		);
	}

	handleClick(event) {
		if (this.isNotPlainLeftClick(event)) {
			return;
		}

		const link = event.target?.closest?.('a[href]');

		if (!link || !document.documentElement.contains(link)) {
			return;
		}

		if (!this.shouldShowLoader(link)) {
			return;
		}

		this.clearTimer();
		this.timer = window.setTimeout(() => {
			if (!event.defaultPrevented) {
				this.showLoader();
			}
		}, 200);
	}

	isSamePageHash(url) {
		const currentUrl = new URL(window.location.href);

		return (
			Boolean(url.hash) &&
			url.origin === currentUrl.origin &&
			url.pathname === currentUrl.pathname &&
			url.search === currentUrl.search
		);
	}

	shouldShowLoader(link) {
		const rawHref = (link.getAttribute('href') || '').trim();
		const target = (link.getAttribute('target') || '').trim().toLowerCase();
		const nonNavigationProtocolPattern =
			/^(javascript:|tel:|mailto:|mail:|sms:|fb:|zalo:)/i;

		if (
			!rawHref ||
			'#' === rawHref ||
			rawHref.startsWith('#') ||
			nonNavigationProtocolPattern.test(rawHref) ||
			link.matches(ThemeAnchorLoaderManager.SKIP_NAVIGATION_SELECTOR) ||
			(target && '_self' !== target)
		) {
			return false;
		}

		let url;

		try {
			url = new URL(rawHref, window.location.href);
		} catch (error) {
			return false;
		}

		if (
			!['http:', 'https:'].includes(url.protocol) ||
			this.isSamePageHash(url)
		) {
			return false;
		}

		return true;
	}

	showLoader() {
		const loader = this.getLoader();

		if (this.rafId) {
			window.cancelAnimationFrame(this.rafId);
		}

		this.rafId = window.requestAnimationFrame(() => {
			this.rafId = null;
			loader.classList.add('is-active');
			loader.setAttribute('aria-hidden', 'false');
		});
	}

	hideLoader() {
		this.clearTimer();

		if (this.rafId) {
			window.cancelAnimationFrame(this.rafId);
			this.rafId = null;
		}

		const loader = document.querySelector(this.loaderSelector);

		if (!loader) {
			return;
		}

		loader.classList.remove('is-active');
		loader.style.display = '';
		loader.setAttribute('aria-hidden', 'true');
	}

	clearTimer() {
		if (!this.timer) {
			return;
		}

		window.clearTimeout(this.timer);
		this.timer = null;
	}

	getLoader() {
		let loader = document.querySelector(this.loaderSelector);

		if (loader) {
			return loader;
		}

		loader = document.createElement('div');
		loader.id = 'spinner-loader';
		loader.setAttribute('aria-hidden', 'true');
		loader.innerHTML = `
			<div class="loader-overlay">
				<div class="loader-spinner" role="status" aria-live="polite">
					<div class="spinner"></div>
					<p>Đang tải...</p>
				</div>
			</div>
		`;
		document.body.appendChild(loader);

		return loader;
	}
}

const loaderOnNavigation = new ThemeAnchorLoaderManager();
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => {
		loaderOnNavigation.init();
	}, {
		once: true,
	});
} else {
	loaderOnNavigation.init();
}
